import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import constants from "constants";
import actions from "actions";
import validator from "services/validator.js";

const {
  API_ERROR_SAGA,
  VALIDATE_ERROR_SAGA,
  ERROR_TYPE_LOGIN_ERROR,
  ERROR_TYPE_REQUEST,
  FORGOT_PASSWORD_SAGA,
  NEW_PASSWORD_SAGA,
  UNSUBSCRIBE_SAGA,
  CREATE_WEBINAR_SAGA,
} = constants;

const { addErrors, logout } = actions;

// Error handler types
const TOAST_HANDLER = "TOAST_HANDLER";
const STATE_HANDLER = "STATE_HANDLER";

const formErrorMessages = (type, response) => {
  let errors = [];
  let handler = null;

  switch (type) {
    case ERROR_TYPE_LOGIN_ERROR:
      // errors = response.status === 500 || response.status === 502 ? 'MedCafe\'s server has encountered a temporary error and is currently unable to complete your request. Please try again in a few minutes. Sorry for the inconvenience.' : 'Invalid email or password';
      errors =
        response.status !== 400
          ? "MedCafe's server has encountered a temporary error and is currently unable to complete your request. Please try again in a few minutes. Sorry for the inconvenience."
          : "This email or password is not recognised";
      handler = TOAST_HANDLER;
      break;
    case FORGOT_PASSWORD_SAGA:
      errors = response && response.data.error_message;
      handler = TOAST_HANDLER;
      break;
    case UNSUBSCRIBE_SAGA:
      errors = response && response.data.error_message;
      handler = TOAST_HANDLER;
      break;
    case NEW_PASSWORD_SAGA:
      errors = response.data && response.data.error_message;
      handler = TOAST_HANDLER;
      break;
    case ERROR_TYPE_REQUEST:
      errors = validator.formatBackendErrors(
        response && response.data.error_messages
      );
      handler = STATE_HANDLER;
      break;
    default:
      errors =
        (response || {}).status === 500 || (response || {}).status === 502
          ? "MedCafe's server has encountered a temporary error and is currently unable to complete your request. Please try again in a few minutes. Sorry for the inconvenience."
          : validator.formatBackendErrors(
              response && response.data.error_messages
            );
      handler = STATE_HANDLER;
      break;
  }
  return [handler, errors];
};

function* handleResponseByStatus(response) {
  const status = response && response.status;
  switch (status) {
    case 401:
      yield put(logout());
      break;
    case 500:
      if (!window.location.href.match(/(medcafe.ie|167.99.201.82)/))
        toast.warn(
          "MedCafe's server has encountered a temporary error and is currently unable to complete your request. Please try again in a few minutes. Sorry for the inconvenience."
        );
      break;
    case 502:
      if (!window.location.href.match(/(medcafe.ie|167.99.201.82)/))
        toast.warn(
          "MedCafe's server has encountered a temporary error and is currently unable to complete your request. Please try again in a few minutes. Sorry for the inconvenience."
        );
      break;
    default:
  }
}

function* handleErrors(requestType, handler, errors, response) {
  yield call(handleResponseByStatus, response);
  switch (handler) {
    case TOAST_HANDLER:
      toast.error(errors);
      break;
    case STATE_HANDLER:
      yield put(addErrors(requestType, errors));
      break;
  }
}

// handlers
function* handleApiError({ requestType, response }) {
  const [handler, errors] = formErrorMessages(requestType, response);
  yield call(handleErrors, requestType, handler, errors, response);
}

function* handleValidateError({ requestType, errors }) {
  const handler = STATE_HANDLER;
  yield call(handleErrors, `${requestType}_FRONTEND`, handler, errors);
}

// SAGAS
function* handleApiErrorSaga() {
  yield takeEvery(API_ERROR_SAGA, handleApiError);
}

function* handleValidateErrorSaga() {
  yield takeEvery(VALIDATE_ERROR_SAGA, handleValidateError);
}

export { handleApiErrorSaga, handleValidateErrorSaga };



// WEBPACK FOOTER //
// ./src/sagas/errors.js